'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ../biro-material-ui/~/react-dom/index.js
 ** module id = 583
 ** module chunks = 0
 **/